import React from 'react';
import smLogo from '../assets/images/SportMinglePrimaryLogo.png'

const Footer = () => {
    return (
        <div className='root-dashboard-footer' data-testid='root-dashboard-footer'>
            <hr className='footer-line' />
            <div className='root-dashboard-footer-content'>
                <p>Powered by</p>
                <img src={smLogo} alt="" />
                <p> Copyright &copy; {new Date().getFullYear()}. All rights reserved.</p>
           </div>
        </div>
    )
}

export default Footer